import type { ComponentPropsWithoutRef } from "react";
import { useMemo } from "react";

import { useSelector } from "react-redux";

import { selectCountriesFilterValue } from "app/pages/sales-intelligence/modules/leads-search-filters";
// eslint-disable-next-line max-len
import ExportSelectTrafficCountryModal from "app/pages/sales-intelligence/sub-modules/management/components/ExportSelectTrafficCountryModal/ExportSelectTrafficCountryModal";
import CountryService from "app/services/CountryService";

type ModalProps = ComponentPropsWithoutRef<typeof ExportSelectTrafficCountryModal>;

type Props = Omit<ModalProps, "countries">;

const ExportSelectTrafficCountryModalContainer = ({ integration, isOpen, onCancel, onExport }: Props) => {
    const countriesFilterValue = useSelector(selectCountriesFilterValue);

    const modalCountries = useMemo(
        () => (countriesFilterValue ?? []).map((id) => CountryService.getCountryById(id)).filter(Boolean),
        [countriesFilterValue],
    );

    return (
        <ExportSelectTrafficCountryModal
            countries={modalCountries}
            integration={integration}
            isOpen={isOpen}
            onCancel={onCancel}
            onExport={onExport}
        />
    );
};

export default ExportSelectTrafficCountryModalContainer;
